import { UIGameCityImprovementTrackerMetropolisTriangle } from '../UIGameCityImprovementTrackerMetropolisTriangle/UIGameCityImprovementTrackerMetropolisTriangle.tsx';
import { UIGameCityImprovementTrackerSquare } from '../UIGameCityImprovementTrackerSquare/UIGameCityImprovementTrackerSquare.tsx';
import styles from './UIGameCityImprovementTrackerColumn.module.scss';
import clsx from 'clsx';
import React from 'react';
export function UIGameCityImprovementTrackerColumn({ cityImprovementType, hasMetropolis, level, className }) {
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, className)
    }, /*#__PURE__*/ React.createElement(UIGameCityImprovementTrackerMetropolisTriangle, {
        cityImprovementType: cityImprovementType,
        className: clsx(styles.triangleWrapper, {
            [styles.hidden]: !hasMetropolis
        })
    }), [
        4,
        3,
        2,
        1,
        0
    ].map((threshold)=>/*#__PURE__*/ React.createElement(UIGameCityImprovementTrackerSquare, {
            active: level > threshold,
            cityImprovementType: cityImprovementType,
            key: threshold
        })));
}
